import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { setAssetBase } from '@/core/render/fontLoader';
import { setWasmBase } from '@/core/validation/decode';
import '@/app/theme.css';

// Приложение может жить в подпапке, поэтому пути к ассетам строятся от base,
// а не от корня домена. Всё загружается только со своего origin.
const assetBase = new URL(import.meta.env.BASE_URL, window.location.href).href;
setAssetBase(assetBase);
setWasmBase(assetBase);

const container = document.getElementById('root');
if (!container) throw new Error('Не найден контейнер #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
